module.exports = __webpack_public_path__ + "img/search-none.872c20b2.png";